import { render, staticRenderFns } from "./WfConsumerCorpPermissionList.vue?vue&type=template&id=8596ac06&scoped=true&"
import script from "./WfConsumerCorpPermissionList.vue?vue&type=script&lang=js&"
export * from "./WfConsumerCorpPermissionList.vue?vue&type=script&lang=js&"
import style0 from "./WfConsumerCorpPermissionList.vue?vue&type=style&index=0&id=8596ac06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8596ac06",
  null
  
)

export default component.exports